import React from "react";
import PropTypes from "prop-types";
import "./Button.scss";
import { bem } from "../../helpers";

export class Button extends React.Component {
  static defaultProps = {
    className: "",
    variant: "primary",
    disabled: false,
  };

  static propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    variant: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
  };

  onClick = (e) => {
    if (this.props && this.props.onClick) {
      this.props.onClick(e);
    }
  };

  render() {
    const { id, variant, disabled, className, children } = this.props;

    return (
      <button
        id={id}
        className={bem(
          "button",
          null,
          [variant && variant, disabled && "disabled"],
          className
        )}
        variant={variant}
        disabled={disabled}
        onClick={this.onClick}
      >
        {children}
      </button>
    );
  }
}

export default Button;
